export const EditFileIcon = () => {
    return (
        <>
            <title>Edit File</title>
            <path d="m2,3c0-.551.449-1,1-1h8v7h7v1.005c.586-.432,1.272-.733,2-.877v-1.542L12.414,0H3C1.346,0,0,1.346,0,3v21h9v-2H2V3Zm11,.414l3.586,3.586h-3.586v-3.586Zm10.122,8.465c-1.134-1.134-3.11-1.134-4.243,0l-7.879,7.878v4.243h4.243l7.878-7.878c.567-.567.879-1.32.879-2.122s-.312-1.555-.878-2.121Zm-1.415,2.828l-7.292,7.293h-1.415v-1.415l7.293-7.292c.377-.378,1.036-.378,1.414,0,.189.188.293.439.293.707s-.104.518-.293.707Z" />
        </>
    );
};
